<template>
  <div class="home">
   <NavbarWorld/>
   <ConocenosWorld/>
   <PromoRepair/>
   <ServiceCarousel/>
   <EmpresasAsociadas/>
   <!--CategoriasView/>
   <UbicacionSection/> 
   <ContactanoWien/>
   <TestimonialsCarousel/> ----->
  
   <FooterSection/>
  </div>
</template>

<script>
import ConocenosWorld from '@/components/ConocenosWorld.vue';
import NavbarWorld from '@/components/NavbarWorld.vue';
import PromoRepair from '@/components/PromoRepair.vue';
import ServiceCarousel from '@/components/ServiceCarousel.vue';
import EmpresasAsociadas from '@/components/EmpresasAsociadas.vue';
/////import CategoriasView from '@/components/CategoriasView.vue';
import FooterSection from '@/components/FooterSection.vue';
///import UbicacionSection from '@/components/UbicacionSection.vue';
///import ContactanoWien from '@/components/ContactanoWien.vue';
////import TestimonialsCarousel from '@/components/TestimonialsCarousel.vue';

export default {
  name: 'HomeView',
  components: {
    NavbarWorld,
    ConocenosWorld,
    PromoRepair,
    ServiceCarousel,
    EmpresasAsociadas,
    FooterSection
  }
}
</script>
